import { isCubeApp, commandMessage } from '@helpers/Constants';
import NativeInterface from '@helpers/NativeInterface';
import Toast from '@widgets/Toast';
import { IPageNavigator, IToOptions} from './index.d';


const PageNavigator: IPageNavigator = {
  async to(options: IToOptions) {
    if(!navigator.onLine) {
      return Toast.show('网络异常，请重试');
    }
    if(isCubeApp()) {
      //在app环境中 跳转到外部小页面时需要打开新的webview容器
      NativeInterface.postMessage(commandMessage.openNewContainer, { url: options.url });
    } else {
      window.location.assign(options.url);
    }
  }
};

export default PageNavigator
